import AGREGAR_FUNCIONARIO from '@/graphql/mutations/administracion/catalogos/funcionarios/agregarFuncionario.gql';
import FUNCIONARIOS from '@/graphql/querys/administracion/catalogos/funcionarios/funcionarios.gql';
import ACTUALIZAR_FUNCIONARIO from '@/graphql/mutations/administracion/catalogos/funcionarios/actualizarFuncionario.gql';
import REMOVER_FUNCIONARIO from '@/graphql/mutations/administracion/catalogos/funcionarios/removerFuncionario.gql';

export default {
  apollo: {
    funcionarios: {
      query: FUNCIONARIOS,
    },
  },
  methods: {
    async mixAgregarFuncionario() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_FUNCIONARIO,
        variables: {
          funcionario: this.funcionario,
        },
        update: (store, { data: { agregarFuncionario } }) => {
          const data = store.readQuery({ query: FUNCIONARIOS });
          data.funcionarios.push(agregarFuncionario);
          store.writeQuery({ query: FUNCIONARIOS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarFuncionario() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_FUNCIONARIO,
        variables: {
          id: this.funcionarioEditar.id,
          funcionario: this.funcionario,
        },
        update: (store, { data: { actualizarFuncionario } }) => {
          const data = store.readQuery({ query: FUNCIONARIOS });
          const { funcionarios } = data;
          const index = funcionarios
            .findIndex((funcionario) => funcionario.id === actualizarFuncionario.id);
          if (index !== -1) {
            funcionarios.splice(index, 1, actualizarFuncionario);
          }
          store.writeQuery({ query: FUNCIONARIOS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarDatosFuncionario() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_FUNCIONARIO,
        variables: {
          id: this.funcionarioId,
          funcionario: this.funcionario,
        },
        update: (store, { data: { actualizarFuncionario } }) => {
          const data = store.readQuery({ query: FUNCIONARIOS });
          const { funcionarios } = data;
          const index = funcionarios
            .findIndex((funcionario) => funcionario.id === actualizarFuncionario.id);
          if (index !== -1) {
            funcionarios.splice(index, 1, actualizarFuncionario);
          }
          store.writeQuery({ query: FUNCIONARIOS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarFuncionario() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_FUNCIONARIO,
        variables: {
          id: this.funcionarioEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: FUNCIONARIOS });
          const { funcionarios } = data;
          const index = funcionarios
            .findIndex((funcionario) => funcionario.id === this.funcionarioEliminar.id);
          if (index !== -1) {
            funcionarios.splice(index, 1);
          }
          store.writeQuery({ query: FUNCIONARIOS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
